
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import APIAdmin from "../Authentification/apiAdmin";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAdmin = async () => {
            try {
                const token = localStorage.getItem("adminToken");
                if (!token) {
                    navigate("/admin/login", { replace: true });
                    return;
                }
                const response = await APIAdmin.get("/admin/admins");
                const data = response.data?.admin || response.data;
                setAdmin(data);
            } catch (error) {
                if (error.response?.status === 401) {
                    localStorage.removeItem("adminToken");
                    navigate("/admin/login", { replace: true });
                }
            } finally {
                setLoading(false);
            }
        };
        fetchAdmin();
    }, [navigate]);

    // const isSuperAdmin = admin?.role === "super_admin";

    // Tant que la colonne "role" n'existe pas en base (avant migration), admin.role
    // vaut undefined/null — on traite ce cas comme un accès complet, identique au
    // comportement d'avant la mise en place du système de sous-comptes.
    const isSuperAdmin = admin?.role === "super_admin" || admin?.role == null;
    const permissions = admin?.permissions || [];

    const hasPermission = (key) => {
        if (!key) return true; // route libre (ex: paramètres)
        if (isSuperAdmin) return true;
        return permissions.includes(key);
    };

    return (
        <AdminAuthContext.Provider value={{ admin, isLoading, isSuperAdmin, permissions, hasPermission }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => useContext(AdminAuthContext);